/** Home snap scroll vs stacked mobile layout */
export const SNAP_MOBILE_MAX_PX = 1000;

/** Tighter content / typography breakpoint */
export const CONTENT_MOBILE_MAX_PX = 600;

export const snapMobileQuery = `@media only screen and (max-width: ${SNAP_MOBILE_MAX_PX}px)`;
export const contentMobileQuery = `@media only screen and (max-width: ${CONTENT_MOBILE_MAX_PX}px)`;
